<template>
	<div>
		<v-row
			justify="space-between"
			align="start"
		>
			<v-col
				cols="12"
				md="6"
				lg="3"
				class="mb-3"
			>
				<v-select
					v-model="chosenCompanies"
					:items="companies"
					item-text="name"
					item-value="id"
					outlined
					dense
					chips
					small-chips
					label="בחר מרכז"
					multiple
				/>
			</v-col>
			<v-col
				cols="12"
				md="6"
				lg="3"
				class="mb-3"
			>
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:return-value.sync="chosenDates"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="dateRangeText"
							label="בחר תווך תאריכים"
							prepend-icon="event"
							readonly
							v-on="on"
						/>
					</template>
					<v-date-picker
						v-model="chosenDates"
						range
						no-title
						scrollable
					>
						<v-spacer />
						<v-btn
							text
							color="primary"
							@click="menu = false"
						>
							Cancel
						</v-btn>
						<v-btn
							text
							color="primary"
							@click="$refs.menu.save(chosenDates)"
						>
							OK
						</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { types as companyTypes } from "src/store/modules/Company.module";
import moment from "moment";

export default {
	name: "TableFilter",
	components: {},
	data () {
		return {
			chosenCompanies: [],
			chosenDates: [moment().subtract(1, "y").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
			menu: false,
		};
	},
	computed: {
		companies () {
			return this.$store.state.CompanyModule.companies;
		},
		dateRangeText () {
			return this.chosenDates.join(" ~  ");
		},
	},
	watch: {
		chosenCompanies (newValue) {
			this.$emit("chosen-companies", newValue);
		},
		chosenDates (newValue) {
			this.$emit("chosen-dates", newValue);
		},
	},
	created () {
		this.$store.dispatch(companyTypes.FETCH);
	},
};
</script>
